export default __webpack_public_path__ + "c21944d20e6f364858e5fad872e0cced.png";